import React from 'react';
import { FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './Contact.css';

export default function Contact() {
    const phoneNumber = '+4915730710451'; // Replace with your actual number
    const message = 'Hallo, ich habe eine Frage.';
    const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    
    return (
        <div className="contact-page">
            <div className="contact-container">
                <div className="contact-header">
                    <h1>Kontaktieren Sie uns</h1>
                    <p className="contact-subtitle">
                        Sie haben Fragen oder möchten ein individuelles Angebot? 
                        Wir sind für Sie da und helfen Ihnen gerne weiter.
                    </p>
                </div>
                
                <div className="contact-grid">
                    <div className="contact-card whatsapp-card">
                        <h3>Schneller Kontakt</h3>
                        <p className="contact-card-description">
                            Erhalten Sie eine unverbindliche Beratung direkt über WhatsApp.
                            Wir antworten in der Regel innerhalb weniger Stunden.
                        </p>
                        <a 
                            href={whatsappLink} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="whatsapp-button"
                        >
                            <FaWhatsapp className="whatsapp-icon" />
                            <div className="whatsapp-text-container">
                                <span className="whatsapp-text">Kontakt via WhatsApp</span>
                                <span className="button-subtext">Schnelle & unverbindliche Beratung</span>
                            </div>
                        </a>
                    </div>

                    <div className="contact-card info-card">
                        <h3>Kontaktdaten</h3>
                        <div className="contact-info-item">
                            <FaPhone className="contact-icon" />
                            <div>
                                <strong>Telefon</strong>
                                <p>+49 1573 071 0451</p>
                            </div>
                        </div>
                        <div className="contact-info-item">
                            <FaEnvelope className="contact-icon" />
                            <div>
                                <strong>E-Mail</strong>
                                <p>info@autozack.de</p>
                            </div>
                        </div>
                        <div className="contact-info-item">
                            <FaMapMarkerAlt className="contact-icon" />
                            <div>
                                <strong>Adresse</strong>
                                <p>Hänfligstr 10<br/>45472 Mülheim an der Ruhr</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
